import { SignalR } from '@/constant/constants'
import { TOKEN_KEY } from '@/constant/common'
import * as signalR from '@microsoft/signalr'
import { getStoredToken } from "@/utils/jwtUtils";

export class RealtimeHubService {
  getHubConnect() {
    const connection = new signalR.HubConnectionBuilder()
      .withUrl(import.meta.env.VITE_URL_API + SignalR.HUB, {
        // The hub requires auth. Read the token on every (re)connect so a
        // silently renewed token is picked up.
        accessTokenFactory: () => getStoredToken() ?? '',
      })
      .withAutomaticReconnect()
      // Information-level logs print the connect URL, which includes the token.
      .configureLogging(signalR.LogLevel.Warning)
      .build();
    return connection;
  }
}

export default RealtimeHubService
